import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import ReactGa from "react-ga";
import { Row, Col, Modal, ModalBody, ModalFooter } from "reactstrap";
import styled from "styled-components";
import "./index.css";
// ASSETS
import imgLegal from "../../assets/tipo_legal.svg";
import imgReja from "../../assets/tipo_reja.svg";
import img2doRetiro from "../../assets/tipo_955.svg";
import ICON_INFO from "../../assets/new_help.svg";
import ICON_EXCLAMA from "../../assets/icons/info_circle.svg";
// COMPONENTES
import ModalSolicitudExitosa from "./Components/ModalSolicitudExitosa"; // Importar el modal
import JubilacionCard from "./Components/JubilacionCard";
import MessageSnack from "../../components/MessageSnack";
import CustomModal from "./Components/custromModal/CustomModal";
import ModalExitoso from "./ModalExitoso";
import ModalFilter from "./ModalFilter";
import ModalMessage from "./ModalMessage";
import ModalAlertaAgencia from "../../components/ModalAlertaAgencia";
import Loading from "../../components/Loading/index.jsx";
import Texto from "./Components/Texto";
import { CardContainer, Page, NotFoundData } from "../../components";
import ModalDeErrorGeneral from "./Components/GeneralErrorModal";
// CONTEXTS
import AuthContext from "../../context/autenticacion/authContext";
import MisDatosContext from "../../context/misdatos/misdatosContext";
import ModalContext from "../../context/modal/modalContext";
import JubilacionContext from "../../context/jubilacion/jubilacionContext";

import { TYPE_OF_PROCEDURE } from "../../types/jubilacion/index";

const Title = styled.div`
  & h1 {
    ${(props) => props.theme.tipography.h4};
    text-align: center;
  }
  & p {
    margin-bottom: 0;
  }
`;

const ContentCheckValidacion = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: ${(props) => props.theme.spacing(2)};
`;
const Jubilacion = (props) => {
  const authContext = useContext(AuthContext);
  const { actualizarTimer } = authContext;

  const misDatosContext = useContext(MisDatosContext);
  const jubilacionContext = useContext(JubilacionContext);
  const {
    misDatosGet,
    mensajeAlertaDatosGet,
    obtenerMisDatosGet,
    limpiarVariablesMisDatosParcial,
    isDataUpdated,
  } = misDatosContext;

  const {
    opcionesMenuPost,
    opcionesMenu,
    procedureActives,
    /*Legal */
    legalData,
    legalDataLoading,
    obtenerProcesoLegalData,
    limpiarObtenerProcesoLegalData,
    createLegalData,
    createLegalDataLoading,
    crearProcesoLegalData,
    limpiarCrearProcesoLegalData,
    /*Reja */
    rejaSgaValidarData,
    rejaSgaValidarLoading,
    enviarRejaSgaValidador,
    limpiarEnviarRejaSgaValidador,
    rejaData,
    rejaDataLoading,
    obtenerProcesoRejaData,
    limpiarObtenerProcesoRejaData,
    createRejaData,
    createRejaDataLoading,
    crearProcesoRejaData,
    limpiarCrearProcesoRejaData,

    accedeSegundoRetiroDataLoading,
    accedeSegundoRetiroData,
    obtenerProcesoSegundoRetiroData,
    limpiarObtenerProcesoSegundoRetiroData,

    createJubilacionData,
    createJubilacionDataLoading,
    crearProcesoJubilacionData,
    limpiarCrearProcesoJubilacionData,

    mensajeAlerta,
  } = jubilacionContext;

  const modalContext = useContext(ModalContext);
  const { setMessage } = modalContext;

  const [modalProcesoFinalizado, setModalProcesoFinalizado] = useState(false);
  const [confirmacionInfo, setConfirmacionInfo] = useState(null);
  const [modalExitoso, setModalExitoso] = useState(null);
  const [modalActualizarDatos, setModalActualizarDatos] = useState(false);
  const [modalCelular, setModalCelular] = useState(null);
  const [modalMessage, setModalMessage] = useState(null);
  const [modalAlerta, setModalAlerta] = useState(null);
  const [modalFilter, setModalFilter] = useState(null);
  const [modalShowError, setModalShowError] = useState(false);
  const [textError, setTextError] = useState([]);
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);

  const [evitarAsesoria, setEvistarAsesoria] = useState(false);
  /*Legal */
  const [modalJubilacionLegal, setModalJubilacionLegal] = useState(false);
  const [validacionLegal, setValidacionLegal] = useState(null);
  const [modalValidacionLegal, setModalValidacionLegal] = useState(false);
  const [modalContinuarAsesoriaLegal, setModalContinuarAsesoriaLegal] =
    useState(false);
  const [modalFinalizarLegal, setModalFinalizarLegal] = useState(false);
  /*Reja */
  const [modalJubilacionReja, setModalJubilacionReja] = useState(false);
  const [validacionReja, setValidacionReja] = useState(null);
  const [modalValidacionReja, setModalValidacionReja] = useState(false);
  const [modalContinuarAsesoriaReja, setModalContinuarAsesoriaReja] =
    useState(false);
  const [modalFinalizarReja, setModalFinalizarReja] = useState(false);
  /* Segunda Decision */
  const [modalSegundaDecision, setModalSegundaDecision] = useState(false);
  const [modalContinuarSegundaDecision, setModalContinuarSegundaDecision] =
    useState(false);

  const [tempTemaDatos, setTempTemasDatos] = useState(null);
  const [sendRequest, setSendRequest] = useState(false);
  const [tramiteId, setTramiteId] = useState(0);

  const [generalErrorModalIsOpen, setGeneralErrorModalIsOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    opcionesMenuPost();
    return () => {
      limpiarObtenerProcesoLegalData();
      limpiarCrearProcesoLegalData();
      // limpiarObtenerProcesoRejaData();
      limpiarCrearProcesoRejaData();
      limpiarObtenerProcesoSegundoRetiroData();
      limpiarCrearProcesoJubilacionData();
      document.body.removeAttribute("style");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mensajeAlertaDatosGet) {
      mostrarMensaje(mensajeAlertaDatosGet);
    } else {
      ReactGa.pageview(window.location.href);
      obtenerMisDatosGet();
    }

    return () => {
      limpiarVariablesMisDatosParcial();
      actualizarTimer();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mensajeAlertaDatosGet]);

  useEffect(() => {
    if (rejaSgaValidarData && tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA) {
      if (rejaSgaValidarData.r_validacion)
        setModalFinalizarReja(!modalFinalizarReja);
    }
    if (rejaSgaValidarData && tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL) {
      setModalFinalizarLegal(!modalFinalizarLegal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejaSgaValidarData]);

  useEffect(() => {
    if (mensajeAlerta) mostrarMensaje(mensajeAlerta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mensajeAlerta]);

  useEffect(() => {
    if (legalData && sendRequest) {
      if (legalData.success) {
        setTempTemasDatos(legalData.data);
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-reja/tramite"
        );
        // if (legalData.data.has_procedure) {
        //   setModalContinuarAsesoriaLegal(true);
        // } else {
        //   setModalJubilacionLegal(true);
        // }
      } else {
        setModalShowError(true);
        setTextError(legalData.errors);
      }
      setSendRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legalData]);
  useEffect(() => {
    if (createLegalData) {
      if (createLegalData.r_validacion === 1)
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-legal/tramite"
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createLegalData]);

  useEffect(() => {
    if (rejaData && sendRequest) {
      if (rejaData.r_validacion === 1) {
        setTempTemasDatos(rejaData.data);
        if (rejaData.data.has_procedure) {
          if (
            localStorage.getItem("isDataUpdated").toString() === "true" &&
            opcionesMenu?.r_jubilacion_anticipada === "1"
          ) {
            setModalContinuarAsesoriaReja(true);
          } else {
            props.history.push(
              "/mi-habitat-digital/afiliado/jubilacion-reja/actualizacion-datos"
            );
          }
        } else {
          if (
            localStorage.getItem("isDataUpdated").toString() === "true" &&
            opcionesMenu?.r_jubilacion_anticipada === "1"
          ) {
            setModalJubilacionReja(true);
          } else {
            props.history.push(
              "/mi-habitat-digital/afiliado/jubilacion-reja/actualizacion-datos"
            );
          }
        }
      } else if (rejaData.r_validacion === 2) {
        setModalShowError(true);
        setTextError([rejaData.message]);
      } else {
        setModalShowError(true);
        setTextError(rejaData.errors);
      }
      setSendRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rejaData]);

  useEffect(() => {
    if (
      localStorage.getItem("firstUpdateData")?.toString() === "true" &&
      opcionesMenu?.r_jubilacion_anticipada === "1"
    ) {
      setTempTemasDatos(rejaData.data);
      if (rejaData.data.has_procedure) {
        setModalContinuarAsesoriaReja(true);
      } else {
        limpiarObtenerProcesoRejaData();
        setModalJubilacionReja(true);
      }
    }
  }, [localStorage.getItem("firstUpdateData")]);

  useEffect(() => {
    if (createRejaData) {
      if (createRejaData.r_validacion === 1)
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-reja/tramite"
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createRejaData]);

  /*SEGUNDO RETIRO*/
  useEffect(() => {
    if (accedeSegundoRetiroData && sendRequest) {
      if (accedeSegundoRetiroData.success) {
        setTempTemasDatos(accedeSegundoRetiroData.data);
        if (accedeSegundoRetiroData.data.has_procedure) {
          setModalContinuarSegundaDecision(true);
        } else {
          setModalSegundaDecision(true);
        }
      } else {
        setModalShowError(true);
        setTextError(accedeSegundoRetiroData.errors);
      }
      setSendRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accedeSegundoRetiroData]);

  useEffect(() => {
    if (createJubilacionData) {
      if (
        createJubilacionData.r_validacion === 1 &&
        tramiteId === TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION
      )
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-segundo-retiro/proceso"
        );
      else if (
        createJubilacionData.r_validacion === 1 &&
        tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL
      )
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-legal/tramite"
        );
      else if (
        createJubilacionData.r_validacion === 1 &&
        tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA
      )
        props.history.push(
          "/mi-habitat-digital/afiliado/jubilacion-reja/tramite"
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createJubilacionData]);

  // Variable para evaluar si se mostrará el car de NUEVO RETIRO
  const onlyNuevoRetiro = (opcionesMenu?.r_segunda_decision == "1") || Boolean(procedureActives?.finishedNuevoRetiro);

  useEffect(() => {
    if ((!onlyNuevoRetiro) && (procedureActives?.finishedReja || procedureActives?.finishedLegal)) {
      setModalProcesoFinalizado(true);
    }
  }, [procedureActives?.finishedReja, procedureActives?.finishedLegal, procedureActives?.finishedNuevoRetiro]);

  const mostrarMensaje = (mensaje) => {
    setMessage(mensaje);
  };

  if (mensajeAlertaDatosGet !== null || mensajeAlerta !== null) return <p></p>;
  if (misDatosGet === null || opcionesMenu === null) return <Loading />;

  const closeBtn = () => {
    setConfirmacionInfo(null);
  };

  const closeModalExitoso = () => () => {
    setModalExitoso(null);
  };

  const closeModalFilter = () => {
    setModalFilter(null);
    if (!misDatosGet.r_persona.r_datos.r_celular) {
      setModalCelular(true);
    }
    setConfirmacionInfo(opcionSeleccionada);
  };
  const onCloseBtnFilter = () => {
    setModalFilter(null);
  };

  const procesarJubilacionSinAlerta = (dato) => {
    setTramiteId(dato);
    setSendRequest(true);
    if (dato === TYPE_OF_PROCEDURE.TYPE_LEGAL)
      props.history.push(
        "/mi-habitat-digital/afiliado/jubilacion-legal/tramite"
      );
    else if (dato === TYPE_OF_PROCEDURE.TYPE_REJA) obtenerProcesoRejaData();
    else if (dato === TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION)
      obtenerProcesoSegundoRetiroData();
    else if (dato === TYPE_OF_PROCEDURE.TYPE_PMO) obtenerProcesoLegalData();
  };

  const closeModalAlerta = () => {
    if (Number(opcionSeleccionada) === 6 || Number(opcionSeleccionada) === 5) {
      setModalFilter(true);
    } else {
      setModalAlerta(null);
      if (!misDatosGet.r_persona.r_datos.r_celular) {
        setModalCelular(true);
      }
      setConfirmacionInfo(opcionSeleccionada);
    }
  };
  const closeModalMessage = () => {
    setModalMessage(null);
  };
  const openModalMessage = () => {
    setModalMessage(true);
    setModalFilter(null);
  };
  const openModalAlertaX = () => {
    setModalFilter(null);
    setModalAlerta(true);
  };
  const closeModalAlertaX = () => () => {
    setModalAlerta(null);
  };

  const fnBtnPrimaryModalJubilacionLegal = () => {
    setModalJubilacionLegal(false);

    if (evitarAsesoria) setEvistarAsesoria(false);

    setModalValidacionLegal(true);
    if (!misDatosGet.r_persona.r_datos.r_celular) {
      setModalCelular(true);
    }
  };

  const fnCloseIconBtnModalJubilacionLegal = () => {
    if (evitarAsesoria) setEvistarAsesoria(false);
    setModalJubilacionLegal(false);
  };
  const fnBtnPrimaryModalValidacionLegal = () => {
    if (validacionLegal === null) return;
    setModalValidacionLegal(false);
    if (validacionLegal === "0") {
      misDatosGet.r_persona.r_datos.r_celular
        ? setModalActualizarDatos(true)
        : setModalCelular(true);
      limpiarObtenerProcesoLegalData();
    } else setModalFinalizarLegal(true);
  };

  const fnBtnPrimaryModalJubilacionReja = () => {
    localStorage.setItem("firstUpdateData", false);
    setModalJubilacionReja(false);

    if (evitarAsesoria) setEvistarAsesoria(false);

    setModalValidacionReja(true);
    if (!misDatosGet.r_persona.r_datos.r_celular) {
      setModalCelular(true);
    }
  };

  const fnCloseIconBtnModalJubilacionReja = () => {
    localStorage.setItem("firstUpdateData", false);
    if (evitarAsesoria) setEvistarAsesoria(false);
    setModalJubilacionReja(false);
  };

  const fnBtnPrimaryModalValidacionReja = () => {
    if (validacionReja === null) return;
    setModalValidacionReja(false);
    if (validacionReja === "0") {
      // misDatosGet.r_persona.r_datos.r_celular
      //   ? setModalActualizarDatos(true)
      //   : setModalCelular(true);
      // limpiarObtenerProcesoRejaData();
      const datos = {
        type_of_procedure_id: 1,
      };
      crearProcesoRejaData(datos);
    } else setModalFinalizarReja(true);
  };
  const fnBtnSecondaryModalValidacionReja = () => {
    setModalValidacionReja(false);
    setModalJubilacionReja(true);
  };

  const checkSomeOption = () => {
    const storedFondos = sessionStorage.getItem("fondos");
    const fondosArray = storedFondos ? JSON.parse(storedFondos) : [];

    // Convertir r_saldo a número, asegurando que siempre tenga un valor válido
    const saldo = (Array.isArray(fondosArray) && fondosArray.length > 0) ? parseFloat(fondosArray[0].r_saldo) || 0 : 0;

    // Evitar errores si `procedureActives` u `opcionesMenu` son null o undefined
    const procedure = procedureActives || {};
    const opciones = opcionesMenu || {};

    return (
      saldo > 0 &&
      !procedure.finishedNuevoRetiro &&
      (
        opciones.r_jubilacion_legal !== "0" ||
        opciones.r_bono_reconocimiento !== "0" ||
        opciones.r_jubilacion_anticipada !== "0"
      )
    );
  };

  return (
    <Page title="Solicitud de Jubilación" paddingMobile="0" showHeader={"mobile"} forceShowHeader={false}>
      {checkSomeOption() ? (
        <CardContainer className="jubilacion-container-card">
          <div className="jubilacion-container">
            <h1 className="jubilacion-title">
              {onlyNuevoRetiro ?
                "Nuevo retiro" : "Solicitud de Jubilación"
              }
            </h1>
            <p className="jubilacion-subtitle">
              {procedureActives?.existeLegal || procedureActives?.existeReja || procedureActives?.existeNuevoRetiro ?
                "Continúa con tu solicitud 100% digital." : "Realiza tu solicitud 100% digital."
              }
            </p>
            {onlyNuevoRetiro && (
              <MessageSnack icon={ICON_EXCLAMA} bgAlert="#EBF3FF" alt="ICON_EXCLAMA" marginTop="1.2em">
                <ul className="note-list">
                  <li className="note-item-subtitle-exclama">
                    Aún tienes saldo en tu Fondo de Jubilación y puedes solicitar un nuevo retiro.
                  </li>
                </ul>
              </MessageSnack>
            )}
            {/* CARDS DE JUBILACION */}
            <div className="jubilacion-grid">
              {/* Mostrar opción de Jubilación Legal */}
              {opcionesMenu?.r_jubilacion_legal !== "0" && !onlyNuevoRetiro && (
                <JubilacionCard
                  tipoJub="legal"
                  icon={imgLegal}
                  buttonLabel={procedureActives?.existeLegal ? "Continuar Solicitud" : "Iniciar Solicitud"}
                  onClick={() => {
                    props.history.push(
                      "/mi-habitat-digital/afiliado/jubilacion-legal/tramite"
                    );
                  }}
                  disabled={
                    (legalDataLoading && tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL) || procedureActives?.finishedLegal
                  }
                  showSpinner={
                    legalDataLoading && tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL
                  }
                />
              )}
              {/* Mostrar opción de Jubilación Anticipada (REJA) */}
              {opcionesMenu?.r_jubilacion_anticipada !== "0" && !onlyNuevoRetiro && (
                <JubilacionCard
                  tipoJub="reja"
                  icon={imgReja}
                  buttonLabel={procedureActives?.existeReja ? "Continuar Solicitud" : "Iniciar Solicitud"}
                  onClick={() => {
                    localStorage.setItem("firstUpdateData", false);
                    procesarJubilacionSinAlerta(TYPE_OF_PROCEDURE.TYPE_REJA);
                  }}
                  disabled={
                    (rejaDataLoading && tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA) || procedureActives?.finishedReja
                  }
                  showSpinner={
                    rejaDataLoading && tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA
                  }
                />
              )}
              {/* Mostrar opción de Segundo Retiro */}
              {onlyNuevoRetiro && (
                <JubilacionCard
                  tipoJub="nuevoRetiro"
                  icon={img2doRetiro}
                  buttonLabel={procedureActives?.existeNuevoRetiro ? "Continuar Solicitud" : "Iniciar Solicitud"}
                  onClick={() => {
                    procesarJubilacionSinAlerta(
                      TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION
                    );
                  }}
                  disabled={
                    (accedeSegundoRetiroDataLoading && tramiteId === TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION) || procedureActives?.finishedNuevoRetiro
                  }
                  showSpinner={
                    accedeSegundoRetiroDataLoading
                  }
                />
              )}
            </div>
            {/* CARDS DE JUBILACION */}
            {!onlyNuevoRetiro && (
              <MessageSnack icon={ICON_INFO} bgAlert="#F8F9FB" alt="ICON_INFO" marginTop="24px">
                <ul className="note-list">
                  <li className="note-item">
                    <b>¿Tienes dudas?</b>
                  </li>
                  <li className="note-item-subtitle">
                    Si deseas obtener más información sobre los diferentes tipos de
                    jubilación y sus requisitos, <a href="https://www.afphabitat.com.pe/pensiones/#tipos-de-pension-de-jubilacion" className="note-link" target="_blank" rel="noopener noreferrer">haz clic aquí</a>.
                  </li>
                </ul>
              </MessageSnack>
            )}
          </div>
        </CardContainer>
      ) : (
        <CardContainer>
          <NotFoundData
            mensaje={
              <span>
                Actualmente, tu cuenta no tiene saldo disponible,
                ya que realizaste el retiro total de tus fondos.
                <br /> Te invitamos a seguir navegando dentro de Mi Habitat
                Digital.
              </span>
            }
            btnText="Entendido"
            url={"/mi-habitat-digital/afiliado/inicio"}
          />
        </CardContainer>
      )}

      {/* MODALES */}
      {modalAlerta && (
        <ModalAlertaAgencia
          dispositivo="desktop"
          buttonCloseTop={true}
          titulo={"!Recuerda que!"}
          view={"Jubilación"}
          dato={opcionSeleccionada}
          closeModal={closeModalAlertaX}
          closeBtn={closeModalAlerta}
          componenteInfo={<Texto opcion={opcionSeleccionada} />}
        // componenteInfo={}
        />
      )}
      {modalFilter && (
        <ModalFilter
          dispositivo="desktop"
          buttonCloseTop={true}
          info={modalFilter}
          titulo={"Validación de jubilación"}
          dato={opcionSeleccionada}
          openModalAlertaX={openModalAlertaX}
          openModalMessage={openModalMessage}
          closeBtn={onCloseBtnFilter}
          closeModal={closeModalFilter}
        />
      )}

      {modalMessage && (
        <ModalMessage
          dispositivo="desktop"
          buttonCloseTop={true}
          titulo={"Solicitud Registrada"}
          closeModal={closeModalMessage}
        />
      )}
      {modalExitoso && (
        <ModalExitoso
          dispositivo="desktop"
          buttonCloseTop={true}
          info={modalExitoso}
          history={props}
          titulo={"Siguiente Paso"}
          closeBtn={closeBtn}
          closeModal={closeModalExitoso}
        />
      )}

      <CustomModal
        showModal={modalActualizarDatos}
        className="beauty-modal"
        toggle={() => {
          setModalActualizarDatos(!modalActualizarDatos);
        }}
        fnCloseIconBtn={() => {
          setModalActualizarDatos(!modalActualizarDatos);
        }}
        title="Confirma tus datos de contacto"
        description={
          <>
            <div className="user-data">
              <div className="field mb-2">
                <span className="label">Correo personal:</span>
                <span className="data">
                  {misDatosGet.r_persona.r_datos.r_correo
                    ? misDatosGet.r_persona.r_datos.r_correo
                    : "No registrado"}
                </span>
              </div>

              <div className="field">
                <span className="label">Celular:</span>
                <span className="data">
                  {misDatosGet.r_persona.r_datos.r_celular
                    ? misDatosGet.r_persona.r_datos.r_celular
                    : "No registrado"}
                </span>
              </div>
            </div>
          </>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          const datos = {
            type_of_procedure_id: tramiteId,
          };
          if (tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL)
            crearProcesoLegalData(datos);
          else if (tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA)
            crearProcesoRejaData(datos);
          else if (tramiteId === TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION)
            crearProcesoJubilacionData(datos);
        }}
        textBtnPrimary="Confirmar datos"
        btnPrimaryLoading={
          createRejaDataLoading ||
          createLegalDataLoading ||
          createJubilacionDataLoading
        }
        hasBtnSecondary={true}
        fnBtnSecondary={() =>
          props.history.push(
            "/mi-habitat-digital/afiliado/informacion/datos-personales"
          )
        }
        textBtnSecondary="Actualizar datos"
        disableBtnSecondary={
          createRejaDataLoading ||
          createLegalDataLoading ||
          createJubilacionDataLoading
        }
      />

      <CustomModal
        showModal={modalCelular}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalCelular(!modalCelular);
        }}
        title="Necesitas actualizar tus datos"
        description={
          <p>
            Por favor, actualiza tu número de celular para continuar con la
            solicitud y poder contactarte.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() =>
          props.history.push(
            "/mi-habitat-digital/afiliado/informacion/datos-personales"
          )
        }
        textBtnPrimary="Actualizar"
        hasBtnSecondary={true}
        fnBtnSecondary={() => setModalCelular(!modalCelular)}
        textBtnSecondary="Cancelar"
      />

      <CustomModal
        showModal={modalJubilacionLegal}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={fnCloseIconBtnModalJubilacionLegal}
        title="Jubilación por Edad Legal"
        description={
          <p>
            Te presentamos esta alternativa de jubilación. Aquí podrás solicitar
            una pensión y/o retiro de hasta el 95.5% de tu fondo a partir de los
            65 años de edad.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={fnBtnPrimaryModalJubilacionLegal}
        textBtnPrimary="Iniciar"
      />

      <CustomModal
        showModal={modalValidacionLegal}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalValidacionLegal(!modalValidacionLegal);
        }}
        title="¿Actualmente percibes una pensión en otro régimen?"
        description={
          <>
            <p style={{ textAlign: "left", marginBottom: "8px" }}>
              Por ejemplo: Ley 20530, Ley 19990, Caja policial y Caja militar.
            </p>

            <ContentCheckValidacion>
              {" "}
              <span className="oneChoice">
                <input
                  type="radio"
                  value={1}
                  className="radio-btn"
                  id="tfa_78"
                  name="tfa_77"
                  onChange={(e) => {
                    setValidacionLegal(e.target.value);
                  }}
                />
                <label className="postRadioField" id="tfa_78" for="tfa_78">
                  <span className="input-radio-faux"></span>Sí, percibo
                </label>
              </span>
              <span className="oneChoice">
                <input
                  type="radio"
                  value={0}
                  className="radio-btn"
                  id="tfa_781"
                  name="tfa_77"
                  onChange={(e) => {
                    setValidacionLegal(e.target.value);
                  }}
                />
                <label className="postRadioField" id="tfa_781" for="tfa_781">
                  <span className="input-radio-faux"></span>No, no percibo
                </label>
              </span>
            </ContentCheckValidacion>
          </>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={fnBtnPrimaryModalValidacionLegal}
        disableBtnPrimary={validacionLegal === null}
        textBtnPrimary="Continuar"
      />

      <CustomModal
        showModal={modalFinalizarLegal}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalFinalizarLegal(!modalFinalizarLegal);
        }}
        title="Recuerda que ..."
        description={
          <p>
            Como actualmente percibes una pensión, puedes solicitar la
            devolución de tu fondo por jubilación en otro régimen (Circular
            040). Te enviamos un correo con los pasos a seguir.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          enviarRejaSgaValidador();
        }}
        btnPrimaryLoading={rejaSgaValidarLoading}
        disableBtnPrimary={rejaSgaValidarLoading}
        textBtnPrimary="Finalizar"
        onClosed={() => limpiarEnviarRejaSgaValidador()}
      />

      <CustomModal
        showModal={modalContinuarAsesoriaLegal}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalContinuarAsesoriaLegal(!modalContinuarAsesoriaLegal);
          setTempTemasDatos(null);
        }}
        title="Jubilación por Edad Legal"
        description={
          tempTemaDatos && tempTemaDatos.status === "finished" ? (
            <p>
              Actualmente usted ya ha culminado con el proceso de Jubilación
              Legal
              <br />
            </p>
          ) : (
            <p>
              Te encuentras en el{" "}
              {`${tempTemaDatos && tramiteId === TYPE_OF_PROCEDURE.TYPE_LEGAL
                ? tempTemaDatos.timeline[tempTemaDatos.step - 1].title
                : ""
                }`}
              .
              <br />
              <br />
              ¿Deseas continuar?{" "}
            </p>
          )
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          if (
            tempTemaDatos &&
            (tempTemaDatos.status === "pending" ||
              tempTemaDatos.status === "in-process")
          )
            props.history.push(
              "/mi-habitat-digital/afiliado/jubilacion-legal/tramite"
            );
          else setModalContinuarAsesoriaLegal(!modalContinuarAsesoriaLegal);
        }}
        textBtnPrimary={
          tempTemaDatos && tempTemaDatos.estado_id === 7 ? "Aceptar" : "Aceptar"
        }
        hasAdvice={false}
      />
      {/* Eliminar ----------------------------------------- */}
      <CustomModal
        showModal={modalJubilacionReja}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={fnCloseIconBtnModalJubilacionReja}
        title="Jubilación Anticipada por Desempleo (REJA)"
        description={
          <p>
            Si estás interesado en iniciar tu Jubilación Anticipada por
            Desempleo (REJA), te presentamos nuestro proceso virtual donde te
            explicaremos y brindaremos asesoría para que puedas elegir la opción
            que mejor se adapte a tus necesidades.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={fnBtnPrimaryModalJubilacionReja}
        textBtnPrimary="INICIAR"
      />
      <CustomModal
        showModal={modalValidacionReja}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalValidacionReja(!modalValidacionReja);
        }}
        title="¿Actualmente percibes una pensión en otro régimen?"
        description={
          <>
            <p style={{ textAlign: "left", marginBottom: "8px" }}>
              Por ejemplo: Ley 20530, Ley 19990, Caja policial y Caja militar.
            </p>

            <ContentCheckValidacion>
              {" "}
              <span className="oneChoice">
                <input
                  type="radio"
                  value={1}
                  className="radio-btn"
                  id="tfa_78"
                  name="tfa_77"
                  onChange={(e) => {
                    setValidacionReja(e.target.value);
                  }}
                />
                <label className="postRadioField" id="tfa_78" for="tfa_78">
                  <span className="input-radio-faux"></span>Sí, percibo
                </label>
              </span>
              <span className="oneChoice">
                <input
                  type="radio"
                  value={0}
                  className="radio-btn"
                  id="tfa_781"
                  name="tfa_77"
                  onChange={(e) => {
                    setValidacionReja(e.target.value);
                  }}
                />
                <label className="postRadioField" id="tfa_781" for="tfa_781">
                  <span className="input-radio-faux"></span>No, no percibo
                </label>
              </span>
            </ContentCheckValidacion>
          </>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={fnBtnPrimaryModalValidacionReja}
        textBtnPrimary="Continuar"
        hasBtnSecondary={true}
        fnBtnSecondary={fnBtnSecondaryModalValidacionReja}
        textBtnSecondary="Volver"
        hasAdvice={false}
      />
      <CustomModal
        showModal={modalFinalizarReja}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalFinalizarReja(!modalFinalizarReja);
        }}
        title="Recuerda que ..."
        description={
          <p>
            Como actualmente percibes una pensión, puedes solicitar la
            devolución de tu fondo por jubilación en otro régimen (Circular
            040). Te enviamos un correo con los pasos a seguir.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          enviarRejaSgaValidador();
        }}
        btnPrimaryLoading={rejaSgaValidarLoading}
        disableBtnPrimary={rejaSgaValidarLoading}
        textBtnPrimary="FINALIZAR"
        onClosed={() => limpiarEnviarRejaSgaValidador()}
      />
      <CustomModal
        showModal={modalContinuarAsesoriaReja}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalContinuarAsesoriaReja(!modalContinuarAsesoriaReja);
          setTempTemasDatos(null);
        }}
        title="Jubilacion Anticipada por desempleo (REJA)"
        description={
          tempTemaDatos && tempTemaDatos.status === "finished" ? (
            <p>
              Actualmente usted ya ha culminado con el proceso de Jubilacion
              Reja
              <br />
            </p>
          ) : (
            <p>
              Actualmente usted se encuentra en el{" "}
              {`${tempTemaDatos && tramiteId === TYPE_OF_PROCEDURE.TYPE_REJA
                ? tempTemaDatos.timeline[tempTemaDatos.step - 1].title
                : ""
                }`}{" "}
              del proceso de <strong>Jubilación Anticipada</strong>.<br />
              ¿Deseas continuar?{" "}
            </p>
          )
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          if (
            tempTemaDatos &&
            (tempTemaDatos.status === "pending" ||
              tempTemaDatos.status === "in-process")
          ) {
            props.history.push(
              "/mi-habitat-digital/afiliado/jubilacion-reja/tramite"
            );
          } else {
            setModalContinuarAsesoriaReja(!modalContinuarAsesoriaReja);
          }
        }}
        textBtnPrimary={
          tempTemaDatos && tempTemaDatos.estado_id === 7 ? "Aceptar" : "Aceptar"
        }
        hasAdvice={false}
      />

      <CustomModal
        showModal={modalShowError}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalShowError(false);
          setTextError("");
        }}
        title="¡Advertencia!"
        description={
          <div className="content-message-validation">
            <p>Estimado afiliado,</p>
            {textError &&
              textError.length > 0 &&
              textError.map((item) => {
                if (
                  item === "No contamos con la información de 7 UIT de sunat"
                ) {
                  return (
                    <p className="item-message-validation">
                      Por el momento no se encuentra disponible el reporte
                      emitido por Sunat para la verificación de sus ingresos
                      bajo el régimen de 4ta. Categoría.
                      <br /> Le sugerimos esperar la actualización del reporte o
                      hacerle seguimiento en la página web de{" "}
                      <a href="https://ww3.sunat.gob.pe/sol.html">SUNAT</a>{" "}
                      ingresando con su clave SOL. Si la información no es
                      correcta, le solicitamos comunicarse con nuestro Call
                      Center al 01 230-2200 Lima o al 0801-14-224 provincias
                      para mayor detalle.
                    </p>
                  );
                } else if (
                  item === "No aplica SYSDE"
                ) {
                  return (
                    <p className="item-message-validation">
                      Lamentamos informarte que actualmente <b>no aplicas a este tipo de jubilación</b>,
                      inténtalo luego. Revisa todos los requisitos {" "}
                      <a href="https://www.afphabitat.com.pe/pensiones/#jubilacion-anticipada-por-desempleo" style={{ textDecoration: "underline", fontWeight: "bold" }}>aquí</a>.{" "}
                    </p>
                  );
                } else {
                  return <p className="item-message-validation">{item}</p>;
                }
              })}
            <p className="message-remenber-validation mt-2">
              Si la información no es correcta, le solicitamos comunicarse con
              nuestro Call Center al 01 230-2200 lima o al 0801-14-224
              provincias para mayor detalle.{" "}
            </p>
          </div>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          setModalShowError(false);
          setTextError("");
        }}
        textBtnPrimary="Cerrar"
      />

      <CustomModal
        showModal={modalSegundaDecision}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalSegundaDecision(!modalSegundaDecision);
        }}
        title="Nuevo Retiro 95.5%"
        description={
          <p>
            <strong>{sessionStorage.getItem("nombreUsuario")}</strong>, si
            deseas iniciar el proceso de Nuevo Retiro 95.5%, te presentamos
            nuestro proceso virtual, donde te explicaremos y asesoraremos para
            que puedas elegir la opción que mejor se adapte a tus necesidades.
          </p>
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          misDatosGet.r_persona.r_datos.r_celular
            ? setModalActualizarDatos(true)
            : setModalCelular(true);
          setModalSegundaDecision(false);
          // props.history.push("/mi-habitat-digital/afiliado/jubilacion-segundo-retiro/proceso");
        }}
        textBtnPrimary="Iniciar"
        hasBtnSecondary={true}
        fnBtnSecondary={() => {
          setModalSegundaDecision(!modalSegundaDecision);
        }}
        textBtnSecondary="Lo realizaré luego"
      />

      <CustomModal
        showModal={modalContinuarSegundaDecision}
        className="beauty-modal"
        backdrop={"static"}
        fnCloseIconBtn={() => {
          setModalContinuarSegundaDecision(!modalContinuarSegundaDecision);
          setTempTemasDatos(null);
        }}
        title="Nuevo Retiro 95.5%"
        description={
          tempTemaDatos && tempTemaDatos.status === "finished" ? (
            <p>
              Actualmente usted ya ha culminado con el proceso de nuevo retiro
              <br />
            </p>
          ) : (
            <p>
              Actualmente usted se encuentra en el{" "}
              {`${tempTemaDatos &&
                tramiteId === TYPE_OF_PROCEDURE.TYPE_SEGUNDA_DECISION
                ? tempTemaDatos.timeline[tempTemaDatos.step - 1].title
                : ""
                }`}{" "}
              del proceso de <strong>Nuevo Retiro 95.5%</strong>.<br />
              ¿Deseas continuar?{" "}
            </p>
          )
        }
        hasBtnPrimary={true}
        fnBtnPrimary={() => {
          if (
            tempTemaDatos &&
            (tempTemaDatos.status === "pending" ||
              tempTemaDatos.status === "in-process")
          ) {
            props.history.push(
              "/mi-habitat-digital/afiliado/jubilacion-segundo-retiro/proceso"
            );
          } else {
            setModalContinuarSegundaDecision(!modalContinuarSegundaDecision);
          }
        }}
        textBtnPrimary={
          tempTemaDatos && tempTemaDatos.estado_id === 7 ? "Aceptar" : "Aceptar"
        }
        hasAdvice={false}
      />
      {/* MODAL PARA SOLICITUDES QUE YA FINALIZARON Y AUN NO ACCEDEN A SEGUNDO RETIRO */}
      <ModalSolicitudExitosa
        open={modalProcesoFinalizado}
        onClose={() => setModalProcesoFinalizado(false)}
        title="Solicitud realizada con éxito"
        description={`Ya has solicitado tu Jubilación ${procedureActives?.finishedLegal ? "por Edad Legal" : "REJA"} y ahora estamos en el proceso de transferencia. Recibirás una notificación cuando se complete.`}
        buttonText="Aceptar"
        onButtonClick={() => {
          setModalProcesoFinalizado(false);
          props.history.push(
            "/mi-habitat-digital/afiliado/inicio"
          );
        }}
      />
    </Page>
  );
};

export default Jubilacion;
